<div *ngIf="resume">
    <ng-container *ngIf="travellers.adult.count > 0">
        <strong>{{ travellers.adult.count }}</strong>
        <strong>
            {{ travellers.adult.name }}
        </strong>
        -
    </ng-container>

    <ng-container *ngIf="travellers.child.count > 0">
        <strong>{{ travellers.child.count }}</strong>
        <strong>
            {{ travellers.child.name }}
        </strong>
        -
    </ng-container>

    <ng-container *ngIf="travellers.infant.count > 0">
        <strong>{{ travellers.infant.count }}</strong>
        <strong>
            {{ travellers.infant.name }}
        </strong>
        -
    </ng-container>
    <ng-container *ngIf="travellers.rooming.count > 0">
        <strong>{{ travellers.rooming.count }}</strong>
        <strong *ngIf="travellers.rooming.count && travellers.rooming.name">
            {{ travellers.rooming.count > 1 && travellers.rooming?.pluralName ? travellers.rooming.pluralName : travellers.rooming.name }}
        </strong>
        -
    </ng-container>
    <ng-container>
        <ng-container *ngFor="let segment of resume.segment">
            <ng-container *ngIf="segment.duration && segment.begin">
                <strong>{{ segment.begin | dateMoment:dateFormat.momentMedium }}</strong> -
                <strong>{{ segment.duration.night }}</strong>
            </ng-container>

            <ng-container *ngIf="segment.duration">
                <ng-container *ngIf="segment.duration.night > 1; else nuit">{{ labels.nights }}</ng-container>
                <ng-template #nuit>{{ labels.night }}</ng-template>
            </ng-container>

            <ng-container *ngIf="segment.end && !isGlobal && isUnitSearch"> -
                <strong>{{ segment.end |  dateMoment:dateFormat.momentMedium }}</strong>
            </ng-container>

            <ng-container *ngIf="segment.property.text && !isGlobal && isUnitSearch">
                - <strong>{{ segment.property.text }}</strong>
            </ng-container>

            <ng-container *ngIf="segment.property.locationName && !isGlobal && isUnitSearch">
                - {{ labels.location }} <strong>{{ segment.property.locationName }}</strong>
            </ng-container>

            <ng-container *ngIf="segment.property.host">
                - {{ labels.hosts }}
                <ng-container *ngIf="!hasAllHosts">
                    <!--<strong *ngFor="let host of segment.property.host; let last = last;">{{ host }}<ng-container *ngIf="!last">, </ng-container></strong>-->
                    <strong [title]="hostsList">{{segment.property.host.length}} / {{nbHosts}}</strong>
                </ng-container>
                <ng-container *ngIf="hasAllHosts">
                    <strong>{{labels.all}}</strong>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="segment.property.geoposition && !isGlobal && isUnitSearch">
                <ng-container *ngIf="segment.property.geoposition.latitude && segment.property.geoposition.longitude">
                    - {{ labels.latitude }}: <strong>{{ segment.property.geoposition.latitude | latLong }}</strong>
                    - {{ labels.longitude }}: <strong>{{ segment.property.geoposition.longitude | latLong }}</strong>
                </ng-container>
                <ng-container *ngIf="segment.property?.geoposition?.radius">
                    - {{ labels.radius }}: <strong>{{ segment.property?.geoposition?.radius | radius }}</strong>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="isRating(segment.property.rating?.standardisationBody) && !isGlobal && isUnitSearch">
                - {{ labels.standardisationBody }}
                <rating [rating]="segment.property.rating.standardisationBody.min"
                        [max]="segment.property.rating.standardisationBody.max"></rating>
            </ng-container>
            <ng-container *ngIf="isRating(segment.property.rating?.traveller) && !isGlobal && isUnitSearch">
                - {{ labels.traveller }}
                <rating [rating]="segment.property.rating.traveller.min"
                        [max]="segment.property.rating.traveller.max"></rating>
            </ng-container>
            <ng-container
                    *ngIf="!isGlobal && isUnitSearch && isRating(segment.property.rating?.brand) && segment.property.rating?.brand.min !== 0">
                - {{ labels.brand }}
                <rating [rating]="segment.property.rating.brand.min"
                        [max]="segment.property.rating.brand.max"></rating>
            </ng-container>
        </ng-container>
    </ng-container>


</div>

<ng-container *ngIf="!resume && !isGlobal">...</ng-container>
<ng-container *ngIf="!resume && isGlobal"><a (click)="toValidate()" [ngStyle]="{'text-decoration': 'underline', 'color': 'blue'}">{{ labels.noRequestText }}</a></ng-container>
